import Image from 'next/image'
import React from 'react'
import icoCompleteRing from '@publicAssets/images/ui/step/ico-complete-ring.svg'
import step3 from '@publicAssets/images/ui/step/step-3.svg'

const StepComplete: React.FC<{
  active?: boolean
}> = ({ active }) => {
  return (
    <>
      <div
        className={`${
          active
            ? 'flex flex-1 flex-row justify-between bg-white'
            : 'flex flex-1 flex-row justify-between bg-gray-100'
        }`}
      >
        <div className="relative flex justify-center items-center w-full flex-row md:justify-around gap-2">
          <div className="w-[9px] h-4 md:w-[19px] md:h-[25px] relative">
            <Image
              src={step3}
              alt={'Step 3'}
              objectFit="contain"
              layout="fill"
              className="absolute top-[-20px] md:top-0"
            />
          </div>
          <div className="flex flex-col items-start">
            <div className="flex flex-col justify-center md:justify-start">
              <h2 className="capitalize text-xs md:text-base font-semibold text-gray-dark leading-5">
                Complete Ring
              </h2>
              <p className="text-xs font-normal mmd:hidden text-gray-dark">
                Review your Ring
              </p>
            </div>
          </div>
          <div className="flex flex-col items-center msm:mt-1 mmd:hidden">
            <Image
              src={icoCompleteRing}
              alt={'Complete Ring'}
              width={33}
              height={33}
            />
          </div>
        </div>
      </div>
    </>
  )
}

export default StepComplete
